/**
 * 브랜드 정의 — 서비스명·문구·테마의 단일 출처(single source of truth).
 * ⚠️ 브랜드명을 소스 어디에도 하드코딩하지 말 것. 반드시 여기서 import.
 *    (웹 title/manifest/favicon은 vite 플러그인이, AI 페르소나는 prompt가,
 *     로고는 BrandLogo 컴포넌트가 여기서 주입받음)
 * 2026-08-18 확정: 타로위드 (Tarot With) — doc/brand-analysis.md §6
 */
export const BRAND = {
  nameKo: '타로위드',
  nameEn: 'Tarot With',
  /** 파일명·도메인 등 URL-safe 표기 */
  slug: 'tarotwith',
  /** 문의 수신 메일 */
  supportEmail: 'help@tarotwith.com',
  /**
   * 정식 도메인 — OG 태그(og:url·og:image)·canonical·sitemap의 절대경로 기준.
   * 공유 미리보기와 검색 색인은 절대 URL을 요구하므로 상대경로로는 안 된다.
   * ⚠️ 도메인 확정/변경 시 여기만 수정.
   */
  siteUrl: 'https://tarotwith.com',
  emoji: '🔮',
  tagline: '함께 보는 타로',
  /** 화면에 그대로 보이는 한 줄 소개 (공유 결과 화면·PWA 앱 설명) — 짧게 유지할 것 */
  description: '혼자서도, 함께서도 보는 타로',
  /**
   * 검색 결과·공유 미리보기에 나가는 설명 (meta description·og:description).
   * 화면용 description과 분리한 이유: 검색 스니펫은 무엇을 하는 서비스인지와
   * 검색어(무료 타로·오늘의 운세 등)를 담아야 클릭으로 이어지는데,
   * 그 길이를 화면 문구로 쓰면 공유 결과 화면이 장황해진다.
   * ⚠️ 한글 기준 80자를 넘기지 말 것 — 구글·네이버가 뒤를 잘라낸다.
   */
  metaDescription:
    '78장을 직접 섞고 뽑으면 AI 상담사가 해석해 드리는 무료 타로. 오늘의 운세·연애·금전·건강 등 주제별로, 혼자서도 함께서도 볼 수 있어요.',
  /** 브라우저 탭 제목 */
  get title() {
    return `${this.nameKo} - ${this.tagline}`;
  },
  /** 밤하늘 배경 (PWA/favicon 타일) */
  themeColor: '#1a1030',
  /** 카드 면 색 */
  surfaceColor: '#241744',
  /** 골드 포인트 (로고·별) */
  accentColor: '#e2b96f',
  /**
   * 라이트 배경용 대응 색 — 밝은 화면에 로고를 얹어야 하는 자리에서 쓴다
   * (앱 마켓·앱인토스 콘솔의 "다크모드 아님" 로고 등).
   * 값은 index.css의 `:root[data-theme='light']` 팔레트와 같은 것을 쓴다:
   * 골드 #e2b96f는 흰 배경에서 대비가 부족해 진한 골드로 내린다.
   */
  lightThemeColor: '#ffffff',
  lightSurfaceColor: '#f7f2e6',
  lightAccentColor: '#8a6210',
  /**
   * 개인정보 처리방침 시행일 (KST). 화면 표기가 여기 한 곳에서 나온다.
   * ⚠️ 방침 내용을 고칠 때는 이 날짜도 함께 올리고, 바뀌기 전에 서비스 안에서 먼저 안내할 것.
   */
  privacyEffectiveDate: '2026년 8월 28일',
  /** 서비스 이용약관 시행일 (KST). 약관을 고칠 때 이 날짜도 함께 올릴 것 */
  termsEffectiveDate: '2026년 10월 11일',
  /** 면책 문구 (푸터) — 타로 의존 위험성 안내 */
  disclaimer:
    '타로는 재미와 위로를 위한 콘텐츠예요. 결과는 가볍게 참고만 하고, 중요한 결정은 언제나 스스로의 판단으로 해주세요. 건강·법률·금전 문제는 꼭 전문가와 상의하세요.',
} as const;
